/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FAnonymousType216,
  SessionAnalysisDTO,
} from '../models/index';
import {
    FAnonymousType216FromJSON,
    FAnonymousType216ToJSON,
    SessionAnalysisDTOFromJSON,
    SessionAnalysisDTOToJSON,
} from '../models/index';

export interface ApiAnalysisSessionIdAbortPostRequest {
    id: number;
}

export interface ApiAnalysisSessionIdGetRequest {
    id: number;
}

export interface ApiAnalysisSessionIdPostRequest {
    id: number;
    sessionAnalysisDTO: SessionAnalysisDTO;
}

/**
 * 
 */
export class AnalysisApi extends runtime.BaseAPI {

    /**
     */
    async apiAnalysisSessionIdAbortPostRaw(requestParameters: ApiAnalysisSessionIdAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAnalysisSessionIdAbortPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/analysis/session/{id}/Abort`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAnalysisSessionIdAbortPost(requestParameters: ApiAnalysisSessionIdAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAnalysisSessionIdAbortPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiAnalysisSessionIdGetRaw(requestParameters: ApiAnalysisSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FAnonymousType216>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAnalysisSessionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/analysis/session/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FAnonymousType216FromJSON(jsonValue));
    }

    /**
     */
    async apiAnalysisSessionIdGet(requestParameters: ApiAnalysisSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FAnonymousType216> {
        const response = await this.apiAnalysisSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAnalysisSessionIdPostRaw(requestParameters: ApiAnalysisSessionIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAnalysisSessionIdPost().'
            );
        }

        if (requestParameters['sessionAnalysisDTO'] == null) {
            throw new runtime.RequiredError(
                'sessionAnalysisDTO',
                'Required parameter "sessionAnalysisDTO" was null or undefined when calling apiAnalysisSessionIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/analysis/session/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionAnalysisDTOToJSON(requestParameters['sessionAnalysisDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAnalysisSessionIdPost(requestParameters: ApiAnalysisSessionIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAnalysisSessionIdPostRaw(requestParameters, initOverrides);
    }

}
